import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import Sound from 'react-sound';
import UIFx from 'uifx';
import styled, { css, keyframes } from 'styled-components';
import { bossDefeated } from '../../actions/learn-fight';
import { useImagesContext } from '../../contexts/ImagesContext';
import { getWanderlandOfStudent } from '../../services/wanderland';
import { getImageUrl } from '../../utils/image';
import Loading from '../layout/Loading';
import { ImgClick } from '../utility';
import bossClearSound from './sounds/boss-clear.mp3';
import { Delay } from '../../utils/delay';
import backgroundSound from './sounds/background.mp3';
import getYardnaphaFile from './sounds/get-yardnapha.mp3';
import consumeYardnaphaSound from './sounds/consume-yardnapha.mp3';
import coinGottenFile from './sounds/coin-gotten.ogg';

const getYardnaphaSound = new UIFx(getYardnaphaFile);
const coinGottenSound = new UIFx(coinGottenFile);

const WanderlandStage = ({
  student,
  wanderlandId,
  handleBack,
  handleStageSelected,
  stageCompletedValue,
  bossDefeatedValue,
  bossDefeated,
  config,
  searchPower,
  issueYardnapha,
  issuePoint,
}) => {
  const { images } = useImagesContext();
  const [wanderland, setWanderland] = useState(null);
  const [notSearchPower, setNotSearchPower] = useState(false);
  const [notFightingPower, setNotFightingPower] = React.useState(false);
  const [gotYardnapha, setGotYardnapha] = useState(false);
  const [issuueYardnaphaDialog, setIssuueYardnaphaDialog] = useState(false);
  const [gotPoint, setGotPoint] = useState(false);
  const [gotYardnaphaProcess, setGotYardnaphaProcess] = useState(
    issueYardnapha > 0,
  );

  async function loadData() {
    console.log('wanderlandId', wanderlandId);
    const retWanderlandOfStudent = await getWanderlandOfStudent(
      student.id,
      wanderlandId,
    );
    console.log('getWanderlandOfStudent', retWanderlandOfStudent.data);
    setWanderland(retWanderlandOfStudent.data);
  }

  async function displayReward() {
    if (issuePoint) {
      setGotPoint(true);
      if (config.isMutedSound === false) {
        coinGottenSound.play();
      }
      await Delay(2000);
      setGotPoint(false);
    }
    if (issueYardnapha) {
      setGotYardnaphaProcess(true);
      setGotYardnapha(true);
      await Delay(1000);
      setGotYardnaphaProcess(false);
      setGotYardnapha(false);
      setIssuueYardnaphaDialog(true);
      if (config.isMutedSound === false) {
        getYardnaphaSound.play();
      }
      await Delay(1000);
      setIssuueYardnaphaDialog(false);
    }
  }

  async function onLoad() {
    await loadData();
    if (bossDefeatedValue) {
      setTimeout(() => {
        bossDefeated(null);
      }, 5000);
    }
    await displayReward();
  }
  useEffect(() => {
    onLoad();
  }, []);

  console.debug('bossDefeatedValue', bossDefeatedValue);
  console.debug('wanderland:stage:searchPower', searchPower);
  console.debug('wanderland.issueYardnapha', issueYardnapha);

  function getStageVideo(stage) {
    return (
      <>
        <StageBlock
          key={stage.id}
          top={stage.imageTop}
          left={stage.imageLeft}
          $canClick={stage.canAccess === true}
          onClick={() => {
            if (stage.canAccess === true) {
              if (searchPower === 0) {
                setNotSearchPower(true);
                setTimeout(() => {
                  setNotSearchPower(false);
                }, 3000);
              } else {
                handleStageSelected(stage, wanderland);
              }
            }
          }}
        >
          <StageVideo
            $display={stage.isPass === false}
            src={
              stage.image
                ? getImageUrl(stage.image)
                : images['image-default.png']
            }
          />
          <Title>{stage.title}</Title>
        </StageBlock>
        {/* <Cicle top={stage.imageTop} left={stage.imageLeft} /> */}
      </>
    );
  }

  function getStageBoss(stage) {
    return (
      <>
        <StageBlock
          key={stage.id}
          top={stage.imageTop}
          left={stage.imageLeft}
          $canClick={stage.canAccess === true && stage.isPass === false}
          onClick={() => {
            if (stage.canAccess === true) {
              if (student.powerType === null) {
                setNotFightingPower(true);
                setTimeout(() => {
                  setNotFightingPower(false);
                }, 3000);
                return;
              }
              handleStageSelected(stage, wanderland);
            }
          }}
        >
          <StageBoss
            $pass={stage.isPass}
            $clear={
              bossDefeatedValue !== null &&
              stage.id === bossDefeatedValue.stageId
            }
            src={
              stage.image
                ? getImageUrl(stage.image)
                : images['image-default.png']
            }
          />
          {bossDefeatedValue !== null &&
            stage.id === bossDefeatedValue.stageId && (
              <>
                <Sound
                  url={bossClearSound}
                  playStatus="PLAYING"
                  loop={false}
                  volume={config.isMutedSound ? 0 : 100}
                ></Sound>
              </>
            )}
        </StageBlock>
        {/* <Cicle top={stage.imageTop} left={stage.imageLeft} /> */}
      </>
    );
  }

  return (
    <Container>
      {wanderland && (
        <>
          <Background src={getImageUrl(wanderland.background)} alt="" />
          {wanderland.haveBoss === false && wanderland.isPass === true && (
            <FullScreenImage src={images['yardnapha-gotten.png']} alt="" />
          )}
          {wanderland.haveBoss === false && wanderland.isPass === false && (
            <FullScreenImage src={images['yardnapha-avalible.png']} alt="" />
          )}
          {gotYardnaphaProcess && (
            <FullScreenImage src={images['yardnapha-avalible.png']} alt="" />
          )}
          {wanderland.stages.map((stage) => (
            <>
              {stage.canAccess && !stage.isPass && (
                <Walk
                  left={stage.walkLeft}
                  top={stage.walkTop}
                  src={images['walk.png']}
                />
              )}
              {stage.stageType === 'video' && getStageVideo(stage)}
              {stage.stageType === 'boss' && getStageBoss(stage)}
            </>
          ))}
          {notSearchPower && (
            <CenterImage src={images['not-search-power.png']} />
          )}
          <Home src={images['home.png']} onClick={handleBack} alt="back" />;
          <YardnaphaGot
            src={gotYardnapha ? images['yardnapha-got.png'] : null}
            alt=""
          />
          {gotYardnapha && (
            <Sound
              url={consumeYardnaphaSound}
              playStatus="PLAYING"
              loop={false}
              volume={config.isMutedSound ? 0 : 100}
            ></Sound>
          )}
          <IssueYardnapha
            src={
              issuueYardnaphaDialog && issueYardnapha === 1
                ? images[`video-yardnapha-issue-one.png`]
                : null
            }
          />
          <IssueYardnapha
            src={
              issuueYardnaphaDialog && issueYardnapha === 2
                ? images[`video-yardnapha-issue-two.png`]
                : null
            }
          />
          <CenterImage
            src={gotPoint > 0 ? images['got-coin-10.png'] : null}
            alt=""
          />
        </>
      )}
      {!wanderland && <Loading />}
      {notFightingPower && (
        <CenterImage src={images['not-fighting-power.png']} alt="" />
      )}
      <Sound
        url={backgroundSound}
        playStatus="PLAYING"
        loop={true}
        volume={config.isMutedSound ? 0 : 100}
      ></Sound>
    </Container>
  );
};

const IssueYardnapha = styled.img`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
`;

const FullScreenImage = styled.img`
  position: absolute;
  top: 0;
  left: 0;
`;

const YardnaphaGot = styled.img`
  position: absolute;
  top: 510px;
  right: 110px;
`;

const CenterImage = styled.img`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
`;

const Container = styled.div`
  width: 1920px;
  height: 1080px;
  position: relative;
`;

const Background = styled.img`
  top: 0px;
  left: 0px;
  width: 1920px;
  height: 1080px;
  position: absolute;
  object-fit: contain;
`;

const Home = styled(ImgClick)`
  position: absolute;
  top: 16px;
  left: 16px;
`;

const Walk = styled.img`
  position: absolute;
  left: ${(props) => props.left}px;
  top: ${(props) => props.top}px;
`;

// const Cicle = styled.span`
// position: absolute;
// top: ${(props) => props.top}px;
// left: ${(props) => props.left}px;
// height: 12px;
// width: 12px;
// background-color: yellow;
// border-radius: 50%;
// display: inline-block;
// transform: translate(-50%, -50%);
// }

// const StageBlock = styled.div`;
//   position: absolute;
//   top: ${(props) => props.top}px;
//   left: ${(props) => props.left}px;
//   transform: translate(-50%, -50%);
// `;

const StageBlock = styled.div`
  position: absolute;
  top: ${(props) => props.top}px;
  left: ${(props) => props.left}px;
  &:hover {
    filter: ${(props) =>
      props.$canClick ? 'drop-shadow(0px 4px 4px black)' : ''};
    transform: ${(props) => (props.$canClick ? 'scale(1.06)' : '')};
  }
`;

const StageVideo = styled.img`
  // position: absolute;
  top: ${(props) => props.top}px;
  left: ${(props) => props.left}px;
  opacity: ${(props) => (props.$display ? 1 : 0)};
`;

const StageBoss = styled.img`
  ${(props) => {
    if (props.$pass && props.$clear) {
      return css`
        position: absolute;
        opacity: 0.2;
        animation: ${fadeOut} 3s ease-in;
      `;
    } else if (props.$pass) {
      return css`
        position: absolute;
        opacity: 0.2;
      `;
    }
    return css`
      position: absolute;
      opacity: 1;
    `;
  }}
`;
// animation: ${fadeOut} 3s ease-in;

const BossClear = styled.img`
  position: absolute;
  // transform: translate(50%, 50%);
`;

const fadeOut = keyframes`
  from {
    opacity: 1;
  }
  to {
    opacity: 0.2;
  }
`;

const Title = styled.div`
  // position: relative;
  margin-top: -60px;
  font-family: 'PSLxText';
  color: white;
  font-weight: bold;
  font-size: 30px;
  // text-stroke: 4px black;
  -webkit-text-stroke: 0.05em black;
  paint-order: stroke fill;
  text-align: center;
  // width: 250px;
  // border: 3px solid black;
`;

// export default WanderlandStage;

const mapStateToProps = ({ learnFight, config }) => ({
  config,
  // questions: learnFight.questions,
  bossDefeatedValue: learnFight.bossDefeatedValue,
  stageCompletedValue: learnFight.stageCompletedValue,
  searchPower: learnFight.searchPower,
});

const mapDispatchToProps = {
  bossDefeated,
};

export default connect(mapStateToProps, mapDispatchToProps)(WanderlandStage);
